export default {
  menuVisible: false,
  notification: "",
  currentUser: null,
  currentLocationId: null,
  recentTournaments: [],

  // tournament listing options
  showThisMonth: true,
  showNextMonth: true,
  showFuture: true,
  showOlder: false,

  // match listing options
  showCompleted: false,
  showInProgress: true,
  showReady: true,
  showPending: true
}



// WEBPACK FOOTER //
// ./src/store/state.js